import React from 'react';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
    return (
        <Box sx={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // backgroundImage: 'url("/NEWimages/page-illustration.svg")',
            // backgroundSize: 'cover',
            backgroundPosition: 'center top',
            backgroundRepeat: 'no-repeat',
        }}>
            <Box sx={{ width: '100%' }}>
                {children}
            </Box>
        </Box>
    );

}

export default Layout;